<template>
    <bill-shell default-title="Data Bundles" default-subtitle="Buy Data Bundles">
        <section id="more" class="section py-5 bg-white">
            <div class="container text-center">
                <h1 class="text-9 font-weight-bold mb-4 mt-2">
                    Never Run Out of Data Again: Top Up Econet & NetOne Bundles on Magetsi!
                </h1>
                <p class="text-3">
                    Staying connected in today's world is crucial. Whether you're browsing the web, staying in touch with
                    loved ones, or managing your business, a reliable internet connection is essential. At Magetsi, we
                    understand that, and that's why we've made it effortless to top up your Econet and NetOne data bundles
                    directly on our user-friendly platform.
                </p>
            </div>
        </section>
        <section class="section py-5 bg-light-4">
            <div class="container">
                <h2 class="text-7 font-weight-bold mb-4 text-center">
                    Say Goodbye to Data Depletion Anxiety!
                </h2>

                <div class="px-5 text-justify">
                    <p class="text-3 mb-4 mt-3">
                        No more scrambling for Wi-Fi hotspots or worrying about unexpected data charges. With Magetsi, you can top up your preferred Econet or NetOne bundle with just a few clicks. We offer a wide variety of options to suit your data usage needs, ensuring you always have enough to stay connected.

                    </p>
                    <h3 class="text-5 font-weight-bold mb-4 text-center">
                        Here's How to Top Up Your Econet Bundle on Magetsi :
                    </h3>
                    <ol class="text-3">
                        <li class="py-1">
                            Visit magetsi.co.zw: Head over to our website and navigate to the "Mobile Top Up" section.

                        </li>
                        <li  class="py-1">
                            Select Your Network: Clearly identify whether you want to top up an Econet or NetOne bundle. In this case, Econet Airtime.

                        </li>
                        <li  class="py-1">
                            Choose "Data Bundle" as Top Up Type: Specify that you're interested in a data bundle top-up.

                        </li>
                        <li  class="py-1">
                            Enter the Phone Number: Accurately input the phone number for which you want to purchase the data bundle.
                        </li>
                        <li  class="py-1">
                            Browse Available Bundles: You will have different data allowances and validity periods. Choose the one that best fits your needs. Choose the one that best fits your needs.
                        </li>
                        <li  class="py-1">
                            Complete the Transaction: Select your preferred payment method (EcoCash, VISA, or Mastercard) and follow the on-screen instructions to finalize the purchase. Once successful, the chosen data bundle will be instantly activated on the selected phone number.

                        </li>

                    </ol>
                    <h3 class="text-5 font-weight-bold mb-4 text-center">
                        How To Top-Up Your Netone Bundles With Magetsi:
                    </h3>
                    <ol class="text-3">
                        <li class="py-1">
                            Visit magetsi.co.zw: Head over to our website and navigate to the "Bundle" section

                        </li>
                        <li  class="py-1">
                            Select Your Network: Clearly identify whether you want to top up an Econet or NetOne bundle. In this case, Netone Bundle.
                        </li>
                        <li  class="py-1">
                            Choose "Data Bundle" as Top Up Type: Specify that you're interested in a data bundle top-up.


                        </li>
                        <li  class="py-1">
                            Enter the Phone Number: Accurately input the phone number for which you want to purchase the data bundle.
                        </li>
                        <li  class="py-1">
                            Browse Available Bundles: You will have different data allowances and validity periods. Choose the one that best fits your needs.

                        </li>
                        <li  class="py-1">
                            Complete the Transaction: Select your preferred payment method (VISA, or Mastercard) and follow the on-screen instructions to finalize the purchase. Once successful, the chosen data bundle will be instantly activated on the selected phone number.
                        </li>

                    </ol>
                    <h3 class="text-5 font-weight-bold mb-4 text-center">
                        Benefits of Topping Up Bundles with Magetsi:
                    </h3>
                    <ul class="text-3">
                        <li class="py-1">
                            Convenience: Top up anytime, anywhere, without visiting a vendor or outlet.
                        </li>
                        <li  class="py-1">
                            Variety: Choose from a wide range of Econet and NetOne bundles to suit your data usage.
                        </li>
                        <li  class="py-1">
                            Speed: Instantaneous processing ensures you can start using your data bundle right away.
                        </li>
                        <li  class="py-1">
                            Security: Our platform utilizes secure payment gateways to protect your financial information.
                        </li>
                        <li  class="py-1">
                            Transparency: See all the details of each bundle (data allowance, validity period, price) before making a purchase.
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="section py-5 bg-white">
            <div class="container">
                <h2 class="text-7 font-weight-bold mb-5 text-center"> Magetsi - Your One-Stop Shop for Mobile Top-Ups! </h2>

                <div class="row">
                    <div class="">
                        <div class="text-3 text-justify">
                            <p>
                                Magetsi goes beyond just Zesa tokens. We're your convenient solution for managing your mobile communication needs as well. In addition to topping up Econet and NetOne bundles, we also offer airtime top-up for both networks.

                            </p>
                            <p>
                                Choose from our selection of Econet Bundles to stay connected to the world. From daily data bundles for browsing social media and streaming videos to weekly and monthly plans for continuous connectivity, we offer flexible options to keep you online without interruptions.

                            </p>

                        </div>
                    </div>

                </div>

            </div>
        </section>
    </bill-shell>
</template>

<script>

export default {
    name: "BundlesShell",
    components: {BillShell: () => import("./bill-shell.vue")},
    metaInfo() {
        return {
            title: "Buy Data Bundles",
        }
    }
}
</script>
